module.exports = __webpack_public_path__ + "img/MQAS_BDO_360IR.a1798de9.gif";